// extracted by mini-css-extract-plugin
module.exports = {"container":"PrescriptionResultsPDFStyles_container__2MA3J","text":"PrescriptionResultsPDFStyles_text__v4zAu","buttons":"PrescriptionResultsPDFStyles_buttons__K47Vc"};